import React, { FC, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Button from '../../../../../components/common/Button';
import { theme } from '../../../../../global';
import { useAppDispatch } from '../../../../../hooks/useAppDispatch';
import { teamActions } from '../../../../../store/slices/team.slice';
import { Inputs } from '../Step1';

import { SECONDS } from './config';
import * as S from './styles';

interface IProps {
  onTimeEnd?: () => void;

  names: Inputs;
}

const LoaderStep: FC<IProps> = ({ onTimeEnd, names }) => {
  const [secondsLeft, setSecondsLeft] = useState(SECONDS);
  const [params] = useSearchParams();
  const dispatch = useAppDispatch();
  const [buttonRedText, setButtonRedText] = useState('');
  const [buttonBlueText, setButtonBlueText] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    if (secondsLeft <= 0) {
      clearTimeout(timeout);

      const randomPlayer = Math.floor(Math.random() * 2);

      if (randomPlayer === 0) {
        setButtonRedText(`${names.player1Name} 
        ${params.get('game_mode') === 'team game' ? 'Team 1' : 'Player 1'}`);
        setButtonBlueText(`${names.player2Name} 
        ${params.get('game_mode') === 'team game' ? 'Team 2' : 'Player 2'}`);
      } else {
        setButtonRedText(`${names.player2Name} 
        ${params.get('game_mode') === 'team game' ? 'Team 1' : 'Player 1'}`);
        setButtonBlueText(`${names.player1Name} 
        ${params.get('game_mode') === 'team game' ? 'Team 2' : 'Player 2'}`);
      }

      dispatch(
        teamActions.setColors({
          player1Color: 'red',
          player2Color: 'blue',
        }),
      );

      dispatch(
        teamActions.setNames({
          player1Name: randomPlayer === 0 ? names.player1Name : names.player2Name,
          player2Name: randomPlayer === 0 ? names.player2Name : names.player1Name,
        }),
      );
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [secondsLeft, dispatch]);

  return (
    <S.Container>
      <S.Description>Random Player Number Assignment</S.Description>
      {secondsLeft > 0 ? (
        <>
          <S.ButtonsContainer>
            <S.GreyBlock />
            <S.BlueBlock />
          </S.ButtonsContainer>
          <S.SecondsLeftText>Results in {secondsLeft} sec.</S.SecondsLeftText>
        </>
      ) : (
        <>
          <S.ButtonsTeamContainer>
            <Button
              variant="team-picker"
              disabled
              teamColor={theme.colors.active_red}
            >
              {buttonRedText}
            </Button>
            <Button
              variant="team-picker"
              disabled
              teamColor={theme.colors.active_blue}
            >
              {buttonBlueText}
            </Button>
          </S.ButtonsTeamContainer>
          <Button
            variant="primary"
            $size="large"
            onClick={onTimeEnd}
          >
            continue
          </Button>
        </>
      )}
    </S.Container>
  );
};

export default LoaderStep;
